module.exports = __webpack_public_path__ + "img/EmptyState_noitem.474868b2.svg";